import React from 'react'
import { Route } from 'react-static'
import Spinner from '../components/Spinner'

import DefaultLayout from './DefaultLayout'
import DashboardLayout from './DashboardLayout'

const layoutComponent = (layout) => {
  switch(layout) {
    case 'dashboard': return DashboardLayout
    default: return DefaultLayout
  }
}

const Redirect = ({history,to}) => {
  history.replace(to)
  return null
}

export default ({layout, authRequired, component: Component, ...rest}) => {
  const Layout = layoutComponent(layout)
  const {authUser,isFetching} = rest
  const path = rest ? rest.path : ''

  // console.log(rest)
  // if(path !== '/signin' && authRequired && !isFetching && (!authUser || !authUser.emailVerified)) {
  //   rest.history.replace('/signin')
  //   return null
  //   //return <Redirect to='/signin'/>
  // }


  return (
    <Route {...rest} render={matchProps =>
      (path !== '/signin' && authRequired && !isFetching && (!authUser || !authUser.emailVerified))
      ? <Redirect history={matchProps.history} to="/signin"/>
      :
      <Layout {...rest}>
        {authRequired && isFetching
          ? <Spinner/>
        : <Component {...rest} {...matchProps}/>
      }
      </Layout>
    }/>
  )
}



// WEBPACK FOOTER //
// /Users/d064310/Development/playland/colorribbon/src/components/LayoutRoute.js